import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const MobileNav = () => {
  return (
    <div className="flex flex-col h-[calc(100vh-80px)] bg-background mt-[80px]">
      <div className="flex-1 overflow-auto">
        <div className="px-4">
          <Link to="/how-it-works" className="block text-xl py-4 hover:text-primary transition-colors">
            How It Works
          </Link>
          
          <Accordion type="single" collapsible>
            <AccordionItem value="who-we-help" className="border-none">
              <AccordionTrigger className="text-xl py-4 hover:text-primary">
                Who We Help
              </AccordionTrigger>
              <AccordionContent>
                <div className="flex flex-col gap-3 pl-2 pb-2">
                  <Link to="/service-businesses" className="text-base text-muted-foreground hover:text-primary transition-colors">
                    Service Businesses
                  </Link>
                  <Link to="/education" className="text-base text-muted-foreground hover:text-primary transition-colors">
                    Education Institutes
                  </Link>
                  <Link to="/restaurants" className="text-base text-muted-foreground hover:text-primary transition-colors">
                    Restaurants
                  </Link>
                </div>
              </AccordionContent>
            </AccordionItem>
          </Accordion>

          <Link to="/case-studies" className="block text-xl py-4 hover:text-primary transition-colors">
            Our Clients
          </Link>
          <Link to="/about" className="block text-xl py-4 hover:text-primary transition-colors">
            About Us
          </Link>
        </div>
      </div>
    </div>
  );
};
